<div class="container">
  <div class="row animated fadeIn fast">
    <div class="mb-2 text-end">
      <a class="btn-add" (click)="btnAdd = !btnAdd" *ngIf="btnAdd">
        <i class="fa fa-plus px-2"></i> Agregar encuesta
      </a>
    </div>
  </div>
  <div class="row animated fadeIn fast" *ngIf="!btnAdd">
    <form autocomplete="off" [formGroup]="formAdd" (ngSubmit)="validateForm()">
      <input type="text" class="form-group px-2" formControlName="name" autofocus>
      <small class="text-danger" *ngIf="campoNoValido('name')">Ingrese un nombre de encuesta</small>

      <button type="submit" class="btn-add">
        <i class="fa fa-plus px-2"></i>Crear
      </button>
      <a (click)="btnAdd = !btnAdd" class="btn-remove">
        <i class="fa fa-remove px-2"></i>
      </a>
    </form>
  </div>
  <div class="row">
    <div class="table-responsive">
      <table class="table">
        <thead class="thead-detail text-center">
          <tr class="table-success">
            <th scope="col">N°</th>
            <th scope="col">Nombre</th>
            <th scope="col">Creado</th>
            <th scope="col">Modificado</th>
            <th scope="col">Estado</th>
            <th scope="col">Vista previa</th>
            <th scope="col"></th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr class="tbody-detail" *ngFor="let obj of surveys; let i = index">
            <td>{{ i + 1 }}</td>
            <td><a class="text-center" [routerLink]="['/encuesta/encuestas/seccion/list', obj.id]">
                {{ obj.name }} </a></td>
            <td>{{ obj.createdAt | date }}</td>
            <td>{{ obj.updatedAt | date }}</td>
            <td class="text-center">
              <div class="label-opened" *ngIf="obj.idstatus===1">ABIERTA</div>
              <div class="label-closed" *ngIf="obj.idstatus===2">CERRADA</div>
              <div class="label-outline" *ngIf="obj.idstatus===3">BORRADOR</div>
              <div class="label-test" *ngIf="obj.idstatus===4">TEST</div>
            </td>
            <td class="text-center"><a class="a-icon" [routerLink]="['/preview/', obj.url]"><i
                  class="fa fa-eye i-icon"></i></a></td>
            <td class="text-center"><a class="a-icon" [routerLink]="['/encuesta/encuestas/edit/', obj.id]"><i
                  class="fa fa-pencil i-icon"></i></a></td>
            <td class="text-center"><a class="a-icon" (click)="remove(obj.id)"><i class="fa fa-trash i-icon"></i></a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <ng-container *ngIf="!hiddenMsg">
    <app-alert [message]="msg.message" [status]="msg.status"></app-alert>
  </ng-container>
</div>